export const isElementVisible = (
  elementToCheck: HTMLElement | null,
  scrollContainer: HTMLElement,
  tolerance?: { top?: number; bottom?: number }
) => {
  return elementToCheck
    ? elementToCheck.getBoundingClientRect().top >=
        scrollContainer.getBoundingClientRect().top + (tolerance?.top || 0) &&
        elementToCheck.getBoundingClientRect().bottom <=
          scrollContainer.getBoundingClientRect().bottom -
            (tolerance?.bottom || 0)
    : false;
};
